export enum UserType {
    SUPER_ADMIN = '12'
    , SUPPORT = '13'
    , MARKETING = '14'
    , MARKETING_MANAGER = '15'
}


// WEBPACK FOOTER //
// ./src/enums/usertype.enum.ts